import { useEffect } from "react";
import classNames from "classnames";
import { useForm } from "react-hook-form";
import { usePriceListState } from "atoms/priceListAtom";

import { BoldText } from "components/BoldText/BoldText";
import { BaseLayout } from "components/BaseLayout/BaseLayout";

import styles from "./styles.module.scss";
import { OptFooter } from "./OptFooter";
import { OptBody } from "./OptBody";

export type FormOptValues = {
  name: string;
  id: string;
};

const Header = ({ title }): JSX.Element => (
  <BoldText className={styles.groupTitle}>
    {title || "Новый прайслист"}
  </BoldText>
);

export const Opt = (): JSX.Element => {
  // файл не должен так называться, это SinglePriceList
  const { priceListState } = usePriceListState();

  const { handleSubmit, control, reset } = useForm<FormOptValues>({
    defaultValues: {
      name: "",
      id: "",
    },
  });

  useEffect(() => {
    reset({
      name: priceListState.activeItem ? priceListState.activeItem.name : "",
      id: priceListState.activeItem
        ? priceListState.activeItem.pricelistid
        : "",
    });
  }, [priceListState]);

  return (
    <BaseLayout
      className={classNames("ml-2 mt-3 mb-3", styles.container)}
      header={
        <Header
          title={
            priceListState.activeItem?.pricelistid
              ? priceListState.activeItem?.name
              : ""
          }
        />
      }
      footer={<OptFooter onSubmit={handleSubmit} reset={reset} />}
    >
      <OptBody
        control={control}
        isEdit={Boolean(priceListState.activeItem?.pricelistid)}
      />
    </BaseLayout>
  );
};
